import React, { Component } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CustomDatePickerButton from "../_common/CustomDatePickerButton";
import overtimeActions from "../../_actions/overtimeActions";

class OvertimeRequestModal extends Component {
  state = {
    name: "",
    projectId: null,
    selectedProject: null,
    requestForDate: null,
    requestedHours: 0,
    justification: "",
    selectedReviewer: null,
    formErrors: {
      selectedProject: null,
      requestForDate: null,
      requestedHours: null,
      justification: null,
      selectedReviewer: null
    }
  };

  componentDidMount() {
    this.setState({ name: this.props.user.fullName });
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });
  handleChange_projSelect = selectedProject =>
    this.setState({ selectedProject });
  handleChange_date = requestForDate => this.setState({ requestForDate });
  handleBlur = e => this.validateForm(e.target.name);

  validateForm = fieldName => {
    const {
      selectedProject,
      requestForDate,
      requestedHours,
      justification
    } = this.state;
    const formErrors = { ...this.state.formErrors };
    switch (fieldName) {
      case "projectSelect":
        if (!selectedProject) formErrors.selectedProject = "Required";
        else formErrors.selectedProject = null;
        break;
      case "requestForDate":
        if (!requestForDate) formErrors.requestForDate = "Required";
        else formErrors.requestForDate = null;
        break;
      case "requestedHours":
        if (!requestedHours) formErrors.requestedHours = "Required";
        else formErrors.requestedHours = null;
        break;
      case "justification":
        if (!justification) formErrors.justification = "Required";
        else formErrors.justification = null;
        break;
      default:
        break;
    }
    this.setState({ formErrors });
  };

  formIsIncomplete = () => {
    const {
      selectedProject,
      requestForDate,
      requestedHours,
      justification,
      formErrors
    } = this.state;
    if (
      !selectedProject ||
      !requestForDate ||
      !requestedHours ||
      !justification ||
      formErrors.selectedProject ||
      formErrors.requestForDate ||
      formErrors.requestedHours ||
      formErrors.justification
    )
      return true;
    return false;
  };

  handleSubmit = e => {
    const { dispatch, user, tabId, toggleOvertimeRequestModal } = this.props;
    e.preventDefault();
    let otDto = { ...this.state };
    otDto.requestedByUserId = user.userId;
    otDto.projectId = otDto.selectedProject.value;
    otDto.projectFullEA = otDto.selectedProject.label;
    otDto.submittedOn = new Date().toJSON();
    otDto.isApproved = false;
    dispatch(overtimeActions.requestOvertime(otDto, tabId)).then(
      toggleOvertimeRequestModal
    );
  };

  render() {
    const {
      name,
      selectedProject,
      requestForDate,
      requestedHours,
      justification,
      selectedReviewer
    } = this.state;
    const {
      showOvertimeRequestModal,
      toggleOvertimeRequestModal,
      userProjects
    } = this.props;
    return (
      <Modal
        isOpen={showOvertimeRequestModal}
        toggle={toggleOvertimeRequestModal}
        className={this.props.className}
        fade={false}
        size={"md"}
      >
        <ModalHeader
          toggle={toggleOvertimeRequestModal}
          className="bg-lightgray"
        >
          Request Overtime
        </ModalHeader>
        <ModalBody>
          <form
            id="addMetsRefForm"
            autoComplete="off"
            onSubmit={this.handleSubmit}
          >
            <div className="card m-2">
              <div className="card-body">
                <div className="form-row form-group mb-2">
                  <label htmlFor="name" className="col-form-label col-sm-4">
                    <b>Name:</b>
                  </label>
                  <div className="col-8">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      value={name}
                      onChange={this.handleChange}
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="projectSelect"
                    className="col-form-label col-sm-4"
                  >
                    <b>Project:</b>
                  </label>
                  <div className="col-8">
                    <Select
                      id="projecSelect"
                      name="projectSelect"
                      value={selectedProject}
                      options={
                        userProjects &&
                        userProjects.map(p => ({
                          value: p.projectId,
                          label: p.fullEA
                        }))
                      }
                      onChange={this.handleChange_projSelect}
                      // onBlur={this.handleBlur}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="requestForDate"
                    className="col-form-label col-sm-4"
                  >
                    <b>OT For:</b>*
                  </label>
                  <div className="col-8">
                    <DatePicker
                      customInput={<CustomDatePickerButton />}
                      name="requestForDate"
                      id="requestForDate"
                      selected={requestForDate}
                      onChange={this.handleChange_date}
                      dateFormat="MM/dd/yyyy"
                      disabled={false}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="requestedHours"
                    className="col-form-label col-sm-4"
                  >
                    <b>Req. Hours:</b>*
                  </label>
                  <div className="col-8">
                    <input
                      type="number"
                      id="requestedHours"
                      name="requestedHours"
                      className="form-control"
                      value={requestedHours}
                      onChange={this.handleChange}
                      // onBlur={this.handleBlur}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="justification"
                    className="col-form-label col-sm-4"
                  >
                    <b>Justification:</b>*
                  </label>
                  <div className="col-8">
                    <textarea
                      id="justification"
                      name="justification"
                      className="form-control"
                      value={justification}
                      onChange={this.handleChange}
                      // onBlur={this.handleBlur}
                    />
                  </div>
                </div>
                <div className="form-row form-group mb-2">
                  <label
                    htmlFor="reviewerSelect"
                    className="col-form-label col-sm-4"
                  >
                    <b>Send Request To:</b>
                  </label>
                  <div className="col-8">
                    <Select
                      id="reviewerSelect"
                      name="reviewerSelect"
                      value={selectedReviewer}
                      options={[]}
                      onChange={this.handleChange_projSelect}
                      isDisabled={true}
                      placeholder="In Development"
                      // onBlur={this.handleBlur_select("reviewerSelect")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter className="bg-lightgray">
          <div className="form-row form-group mb-0">
            <input
              className="btn btn-primary"
              name="addMetsRef"
              type="submit"
              form="addMetsRefForm"
              onClick={this.handleSubmit}
              value="Request"
              disabled={this.formIsIncomplete()}
            />
            <button
              className="btn btn-secondary ml-2"
              color="secondary"
              onClick={toggleOvertimeRequestModal}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.authentication.user,
  userProjects: state.projects.assignedProjectsForUser
});

export default connect(mapStateToProps)(OvertimeRequestModal);
